import * as angular from "angular";
import {IController, IIntervalService} from "angular";
import {WorkloadService} from "../../services/workload-service.service";
import {WorkingUnitType} from "../../types/working-unit.type";
import {WorkLoadAgentWithShiftsModel} from "../../models/work-load-agent-with-shifts.model";
import * as _ from "lodash";
import {workLoadModel} from "../../models/work-load.model";

export class WorkloadToolbarComponent implements IController {

  branchId: string;
  doReload?: boolean;

  public loadingState: boolean = false;
  public loadingFuture: boolean = false;
  public attendanceState: WorkLoadAgentWithShiftsModel;
  public attendanceFuture: WorkLoadAgentWithShiftsModel;
  public workload: workLoadModel;

  private intervalRef: any;

  /* @ngInject */
  constructor(private workloadService: WorkloadService,
              private $mdPanel,
              private $interval: IIntervalService) {
  }

  $onInit() {
    this._getAttendanceState();
    this._getAttendanceFuture();
    this._getWorkload();
    this._setInterval();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.branchId && !changes.branchId.isFirstChange()) {
      this._getAttendanceState();
      this._getAttendanceFuture();
      this._getWorkload();
    }
    if (changes.doReload && !changes.doReload.isFirstChange()) {
      if (!!this.doReload) {
        this._getAttendanceState();
        this._getAttendanceFuture();
        this._getWorkload();
      }
    }

  }

  $onDestroy() {
    this.destroyInterval();
  }

  onShowPanel($event, data) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.CENTER,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .withAnimation(this.$mdPanel.animation.FADE);

    const dataRef = data;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<workload-toolbar-panel data="ctrl.dataRef"></workload-toolbar-panel>',
      controller: function () {
        this.dataRef = dataRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, selectedIds) => {
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onRefresh() {
    this._getAttendanceState();
    this._getAttendanceFuture();
    this._getWorkload();
  }

  private _getWorkload() {
    this.workloadService.getWorkLoad(this.branchId, WorkingUnitType.Branch)
      .then((workload: workLoadModel) => {
        this.workload = workload;
      })
  }

  private _getAttendanceState() {
    this.attendanceState = undefined;
    this.loadingState = true;
    this.workloadService.getAttendanceState(this.branchId, WorkingUnitType.Branch)
      .then((res: WorkLoadAgentWithShiftsModel) => {
        this.attendanceState = res;
      })
      .finally(() => {
        this.loadingState = false;
      })
  }

  private _getAttendanceFuture() {
    this.attendanceFuture = undefined;
    this.loadingFuture = true;
    this.workloadService.getAttendanceFuture(this.branchId, WorkingUnitType.Branch)
      .then((res: WorkLoadAgentWithShiftsModel) => {
        this.attendanceFuture = res;
      })
      .finally(() => {
        this.loadingFuture = false;
      })
  }

  private _setInterval() {
    this.destroyInterval();
    this.intervalRef = this.$interval(() => {
      this._getAttendanceState();
      this._getAttendanceFuture();
      this._getWorkload();
    }, 300000); // 5 minutes
  }

  private destroyInterval() {
    if (this.intervalRef) {
      this.$interval.cancel(this.intervalRef);
      this.intervalRef = undefined;
    }
  }

}

angular
  .module('bringoz.admin.workload')
  .component('workloadToolbar', {
    bindings: {
      branchId: '<',
      doReload: '<?'
    },
    template: require('./workload-toolbar.html').default,
    controller: WorkloadToolbarComponent
  });
